// Required fields are marked with an asterisk, so an empty field is never red
const hasValue = (value: any) =>
  Array.isArray(value) ? value.length > 0 : Boolean(value?.label ?? value);

export const getDynamicValidationColorsGlobal = (
  field: { value: any },
  isInvalid: boolean
): string => {
  if (!hasValue(field.value)) return 'validatedPurple';
  return isInvalid ? 'validatedRed' : 'validatedGreen';
};

export const getDynamicValidationColorsTextArea = (
  field: { value: any },
  fieldState?: any,
  limit?: number,
  min?: number,
  getCharacterCount?: (value?: string) => number
): string => {
  const valueLength = getCharacterCount
    ? getCharacterCount(field.value)
    : field.value?.length || 0;

  if (valueLength === 0) return 'validatedPurple';
  if (
    fieldState?.error ||
    (limit && valueLength > limit) ||
    (min && valueLength < min)
  )
    return 'validatedRed';
  return 'validatedGreen';
};

export const getDynamicValidationColors = (field: { value: any }): string =>
  hasValue(field.value) ? 'validatedGreen' : 'validatedPurple';
